'use client'
import React from 'react'
import styles from './page.module.scss'
import { FaSearch } from 'react-icons/fa'
import SearchForm from './SearchForm'
import SearchButton from './SearchButton'

const Index = ({ serachIcon = true, showSearch, setShowSearch, bannerSearch = false, categoryData = [] }) => {
	return (
		<div className={`${styles.HeaderSearch} ${showSearch && styles.HeaderSearchActive}`}>
			{!showSearch && (
				<div
					className={`${styles.SearchFieldLanding} ${showSearch && 'rounded-0 rounded-top-4'} ${
						bannerSearch && styles.inputSearchBackground
					}`}
				>
					<div className={`${styles.searchFieldContent} col-12`}>
						<div className='d-flex align-items-center gap-2 px-2 w-100 justify-content-between'>
							<div
								onClick={(e) => !showSearch && setShowSearch(!showSearch)}
								className={`d-flex align-items-center gap-2 w-100 cursor-pointer`}
							>
								{!showSearch && <SearchButton bannerSearch={bannerSearch} />}
							</div>
						</div>
					</div>
					{serachIcon && (
						<div
							className={`align-items-center text-end position-absolute ${styles.serachIcon}`}
							onClick={(e) => !showSearch && setShowSearch(!showSearch)}
						>
							<FaSearch className={styles.searchButton} size={20} />
						</div>
					)}
				</div>
			)}
			{showSearch && (
				<SearchForm
					serachIcon={serachIcon}
					showSearch={showSearch}
					setShowSearch={setShowSearch}
					bannerSearch={bannerSearch}
					categoryData={categoryData}
				/>
			)}
		</div>
	)
}

export default Index
